import { render } from "./MenuContentItemValueUpDownBox.vue?vue&type=template&id=2cf916d6"
import script from "./MenuContentItemValueUpDownBox.vue?vue&type=script&lang=js"
export * from "./MenuContentItemValueUpDownBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__